export default "__VITE_ASSET__NGstyovd__"